import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function MissingReportId() {
  return (
    <>
      <title>❌ Report Details - Researchly</title>
      <Card>
        <CardHeader>
          <CardTitle>Missing report id</CardTitle>
          <CardDescription>
            Please navigate from the reports page.
          </CardDescription>
        </CardHeader>
      </Card>
    </>
  );
}
